<mat-sidenav-container class="form-container">
  <mat-sidenav class="custom-sidenav" #sidenav disableClose fixedTopGap="70" fixedInViewport mode="side" opened>
    
      <div class="task-toolbar d-flex justify-content-between align-items-center">
        <mat-form-field id="search-input" appearance="fill" class="mx-3 w-100">
          <input
            [disabled]="disableSearch"
            matInput
            placeholder="Durchsuchen"
            [(ngModel)]="searchTerm"
            (input)="filterTemplates()" />
          <mat-icon matPrefix>search</mat-icon>
        </mat-form-field>
      </div>

      <div class="template-list">
        @if (workTaskTemplates.length > 0) {
          <mat-list>
            <!-- <mat-accordion>
              <mat-expansion-panel expanded>
                <mat-expansion-panel-header>
                  <mat-panel-title>example</mat-panel-title>
                </mat-expansion-panel-header>
                <mat-list dense>
                  <mat-list-item>example item</mat-list-item>
                  <mat-list-item>example item</mat-list-item>
                </mat-list>
              </mat-expansion-panel>
            </mat-accordion> -->

            <!--  @for (template of workTaskTemplates; track template.id) { -->
            @for (group of groupBy(filteredTemplates, 'groupId'); track group.id ) {
              @if (group?.id){
                <div mat-subheader class="group-name">{{ getGroupName(group.id) }}</div>
              }
              @if (group?.id === '__no_key') {
                <hr style="border: 1px solid #c2c2c2">
              }
              @for (template of group.templates; track template.id) {
                <mat-list-item
                  (click)="onSelectTask(template)"
                  [class.active]="isTaskActive(template.id)"
                  matTooltipShowDelay="1500"
                  matTooltip="ID: {{ template.id }}"
                >
                  <div class="d-flex w-100 justify-content-between">
                    <span>{{ template.title }}</span>
                    @if (isTaskActive(template.id)) {
                      <mat-icon style="color:var(--warmOrange)">chevron_right</mat-icon>
                    }
                  </div>
                </mat-list-item>
              }
            }
          </mat-list>
        }
        @else {
          <div class="h-100 align-items-center d-flex justify-content-center">
            <p>Nichts vorhanden.</p>
          </div>
        }
      </div>
      
  </mat-sidenav>
  <mat-sidenav-content>
    <app-work-task-form></app-work-task-form>
  </mat-sidenav-content>
</mat-sidenav-container>